import { render, staticRenderFns } from "./abstract-page-toolbar.vue?vue&type=template&id=06511ce2"
import script from "./abstract-page-toolbar.vue?vue&type=script&lang=js"
export * from "./abstract-page-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports